import { apiClient } from '~/shared/api/data-ingestion-api'

export function getDisplayName(reviewer: apiClient.User | undefined) {
  if (!reviewer) return ''
  return `${reviewer.first_name || ''} ${reviewer.last_name || ''}`.trim()
}
